import SocialSharingModalProvider from './SocialSharingModalProvider';

export default SocialSharingModalProvider;
